<div class="content">
  <div class="imprintWrapper">
    <div class="imprint">
      <h1>Impressum</h1>

      <h2>SYMBOX</h2>

      <p>
        symbox Gesellschaft für Medienversorgung mbH<br />
        Am Saaraltarm 1<br />
        D-66740 Saarlouis<br />
        Tel.: 0800-103-0010<br />
        Fax: 06831-50318-126<br />
        info&#64;symbox.de<br />
        www.symbox.de
      </p>

      <h3>Bestellung, Beratung und Vertrag:</h3>

      <p>info&#64;symbox.de</p>

      <h3>Kundenservice:</h3>

      <p>0800-103-0010</p>

      <h3>Geschäftsführer:</h3>

      <p>
        Geschäftsführer: Andreas Pfisterer, Anna Dimitrova, Pascal Koster, Christian Liversidge Duer, Ruben Queimano, Roman Schachtsiek<br />
        Rechtsform: Gesellschaft mit beschränkter Haftung<br />
        Sitz der Gesellschaft: Saarlouis<br />
        Registergericht: Amtsgericht Saarbrücken-HRB 19065<br />
        Steuernummer: 010/118/07826<br />
      </p>

      <h3>Haftungsauschluss:</h3>

      <p>
        Wir haben alle Anstrengungen unternommen, um korrekte Informationen auf dieser Website zum Zeitpunkt der Veröffentlichung
        sicherzustellen. Die symbox Gesellschaft für Medienversorgung GmbH übernimmt keine Garantie für die Vollständigkeit, Richtigkeit und
        Aktualität für die auf dieser Website von uns bereitgestellten Informationen und die ausdrücklich oder konkludent als fremde Inhalte
        gekennzeichnete Informationen. Im Zusammenhang mit den letztgenannten Informationen haftet die symbox Gesellschaft für
        Medienversorgung mb Hauch nicht für deren Rechtmäßigkeit und deren Eingreifen in Rechtsgüter Dritter. Gleiches gilt für Inhalte von
        Websites, auf die durch einen Link verwiesen wird.Die symbox Gesellschaft für Medienversorgung GmbHist jederzeit, ohne vorherige
        Ankündigung, befugt Änderungen oder Ergänzungen der auf dieser Website einsehbaren Informationen vorzunehmen oder diese zu
        entfernen. Die symbox Gesellschaft für Medienversorgung GmbH übernimmt weltweit keine Haftung gegenüber dritten Parteien für
        Personenschäden, Folgeschäden, mittelbare Schäden, Vermögensschände oder sonstige Schäden., die durch den Gebrauch oder das
        Vertrauen auf die auf dieser Website enthaltenen Informationen bestehen.
      </p>

      <h3>Aufsichtsbehörde</h3>

      <p>
        Bundesnetzagentur für Elektrizität, Gas, Telekommunikation, Post und Eisenbahnen<br />
        Tulpenfeld<br />
        453113 Bonn<br />
        <a href="https://bundesnetzagentur.de" target="_blank">https://bundesnetzagentur.de</a>
      </p>

      <h3>Außergerichtliche Streitbeilegung</h3>

      <p>
        a) Information zur Verbraucherstreitbelegung nach § 36 Verbraucherstreitbeilegungsgesetz (VSBG)<br /><br />

        Verbraucherschlichtstelle Telekommunikation der Bundesnetzagentur in Bonn<br /><br />

        Nach § 47a Telekommunikationsgesetz besteht die Möglichkeit, ein Schlichtungsverfahren vor der Bundesnetzagentur in Bonn
        einzuleiten, wenn Streit darüber besteht, ob die symbox Gesellschaft für Medienversorgung GmbH bestimmte, in § 47a TKG aufgeführte
        Endkundenrechte nicht berücksichtigt hat. Der Antrag ist an die Bundesnetzagentur in Bonn zu richten. Die symbox Gesellschaft für
        Medienversorgung GmbH ist bereit an Schlichtungsverfahren von der Bundesnetzagentur teilzunehmen. Weitere Informationen zum
        Verfahrensablauf erhalten Sie auf der Internetseite der Bundesnetzagentur<br /><br />
      </p>

      <p>
        b) Sonstige Streitfälle<br /><br />
        symbox Gesellschaft für Medienversorgung GmbH schließtdie Teilnahme an einem Streitbeilegungsverfahren vor einer anderen
        Verbraucherschlichtungsstelle aus. Die symbox Gesellschaft für Medienversorgung GmbH ist gerne bereit Streitigkeiten mit ihren
        Kunden im direkten Kontakt zu klären. Bitte wenden sie sich dazu an unseren Kundenservice.<br /><br />
      </p>

      <p>
        c) Informationen zur Online-Streitbeilegung nach Artikel 14 Abs. 1 ODR-VO<br /><br />
        Streitigkeiten zwischen Verbrauchern und Händlern im Zusammenhang mit Online-Kaufverträgen oder Online-Dienstleistungsverträgen
        können über eine Plattform zur Online-Streitbeilegung der Europäischen Union beigelegt werden. Die Plattform erreichen Sie unter:
        <a href="http://ec.europa.eu/consumers/odr" target="_blank">http://ec.europa.eu/consumers/odr</a>
      </p>

      <h3>Urheberrecht</h3>

      <p>
        Alle Rechte vorbehalten. Alle auf dieser Website veröffentlichten Inhalte unterliegen dem Schutz des Urheberrechts und anderer
        Schutzgesetze. Der Rechtsschutz gilt auch gegenüber Datenbanken und ähnlichen Einrichtungen. Soweit nicht anders angegeben, sind
        alle Markenzeichen dieser Website markenrechtlichgeschützt.
      </p>

      <h3>Inhaltlich verantwortlich</h3>
      <p>symbox Gesellschaft für Medienversorgung mbH</p>
    </div>
  </div>
</div>
